import React, { useEffect, useRef } from 'react';
import { Player } from '@lordicon/react';
import ScrollReveal from "scrollreveal";
import styles from './smallbox.module.css';

const SmallBox = ({ text, icon, desc }) => {
  const playerRef = useRef(null);
  const iconRef = useRef(null);

  useEffect(() => {
    if (playerRef.current) {
      playerRef.current.playFromBeginning();
    }

    ScrollReveal().reveal(`.${styles.iconWrapper}`, {
      duration: 1000,
      distance: "30px",
      origin: "bottom",
      easing: "ease-out",
      reset: false,
      viewFactor: 0.2,
      interval: 300,
      delay: 200,
      scale: 1,
    });
  }, []);

  const handleComplete = () => {
    setTimeout(() => {
      if (playerRef.current) {
        playerRef.current.playFromBeginning();
      }
    }, 2500);
  };

  return (
    <div className={styles.container}>
      <div ref={iconRef} className={styles.iconWrapper}>
        {icon && (
          <Player
            icon={icon}
            ref={playerRef}
            size="50px"
            loop={true}
            onComplete={handleComplete}
            colorize="#FFFFFF"
          />
        )}
      </div>
      <p className={styles.text}>{text}</p>
      {desc && <p className={styles.desc}>{desc}</p>}
    </div>
  );
};

export default SmallBox;